/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

export default stackDelete;



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/_stackDelete.js
// module id = 1687
// module chunks = 2